export default "__VITE_PUBLIC_ASSET__70c82934__"